import { configMgr } from '@nab/nab-x-sdk-browser';
import { InMemoryCache } from 'apollo-cache-inmemory';
import ApolloClient from 'apollo-boost';

// isCanary must be resolved by the caller (a React component) via useCanaryCheck()
// and passed in as a plain boolean — hooks cannot be called inside Apollo request callbacks
const getApolloClient = (auth: string, isCanary?: boolean) => {
    const cache = new InMemoryCache();

    const safeCanaryCheck = () => isCanary === true;

    const clientGatewayHost = configMgr.get('CLIENT_GW_HOST');

    const client = new ApolloClient({
        request: operation => {
            const headers: Record<string, unknown> = {
                authorization: `Bearer ${auth}`,
            };

            if (safeCanaryCheck()) {
                headers['x-canary'] = true;
            }

            operation.setContext({ headers });
        },
        // For local dev, set CLIENT_GW_HOST in .env.local
        // NABX_EXTERNAL_DEVELOPER_SHELL_FRONTEND_CLIENT_GW_HOST=localhost:<<bff port>>
        // OR
        // NABX_EXTERNAL_DEVELOPER_SHELL_FRONTEND_CLIENT_GW_HOST=localhost:<<frontend port because we have proxy in package.json>>
        uri: `https://${clientGatewayHost}/v1/open/external-shell-miniapp-bff`,
        credentials: 'include',
        cache
    });

    return client;
};

export { getApolloClient };
